"use client"

import { useEffect } from "react"
import { isOptedOutClient } from "@/lib/tracking/optOut"
import { initMetaPixel, loadFbeventsScript } from "@/lib/tracking/storefrontEvents"

/**
 * Carga el pixel de Meta del dueño en SU página. Se renderiza dentro de la
 * página de la tienda (app/order/[slug]/page.tsx) y NO en un layout: así queda
 * fuera de /order/<slug>/pagar (pago de paso, donde monta North) y de
 * /order/<slug>/mesa/<token> (QR de mesa).
 *
 * La exclusión (cookie o Global Privacy Control) solo se conoce en el
 * navegador, así que todo va en un efecto: nada de terceros se pide antes de
 * saber que el cliente no se excluyó. No pinta nada.
 */
export function StorefrontTracking({ metaPixelId }: { metaPixelId: string | null }) {
  useEffect(() => {
    if (!metaPixelId) return
    try {
      if (isOptedOutClient(document, navigator as { globalPrivacyControl?: boolean })) return
      initMetaPixel(window as never, metaPixelId)
      loadFbeventsScript(document)
    } catch {
      // medición: nunca rompe la tienda
    }
  }, [metaPixelId])
  return null
}
